import Footer from "../components/Footer";
import NavBar from "../components/Navbar/NavBar";
import ServiceDetail from "../components/ServiceDetail";
import Trainings from "../images/training.png";

export default function Training() {
  return (
    <>
        <NavBar />
        <ServiceDetail
          titleKey="services.s5_title"
          descriptionKey="services.s5_more"
          image={Trainings}
          highlights={[
              "services.s5_point_1",
              "services.s5_point_2",
              "services.s5_point_3",
          ]}
        />
        <Footer />
    </>
  );
}
